import {} from './event.js';
/**
 * An event processor that stops events from being sent in case the user didn't grant the consent.
 * This is usually used for privacy reasons (e.g., GDPR)
 */
export const blockWitoutUserConsent = (hasUserGivenConsent) => {
    return {
        processEvent: (event) => {
            if (!hasUserGivenConsent()) {
                return undefined;
            }
            return event;
        },
    };
};
//# sourceMappingURL=eventProcessor.js.map